import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAllData } from "../../../Utils/firebaseServices";
import LoadingCircular from "../../../loader/LoadingCircular";

function EmployeeStatus() {
  const { id } = useParams();
  const [assignedData, setAssignedData] = useState([]);
  const [employeeInfo, setEmployeeInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    const fetchAssignments = async () => {
      try {
        // 1. Get employee info
        await getAllData("financeUserPortal", (employees) => {
          const employee = employees.find((emp) => emp.id === id);
          setEmployeeInfo(employee || {});
        });

        let contacts = [];

        // 2. Get contacts assigned to this employee
        await getAllData("contactMessages", (allContacts) => {
          contacts = allContacts.filter(
            (item) => item.assignedTo?.selectedEmpid === id
          );
        });

        // 3. Get comments for those contacts
        await getAllData("employeeTaskComment", (allCommentDocs) => {
          const commentMappedContacts = contacts.map((contact) => {
            const match = allCommentDocs.find(
              (doc) => doc.contactId === contact.id
            );

            const employeeComments = (match?.comment || []).filter(
              (c) => (c.empID ?? "").toString().trim() === id?.toString().trim()
            );

            const formattedComments = employeeComments.map((c) => ({
              comment: c.comment || "-",
              status: c.status || "-",
              timestamp: c.timestamp?.seconds
                ? new Date(c.timestamp.seconds * 1000).toLocaleDateString()
                : "-",
            }));

            return {
              ...contact,
              comments: formattedComments,
            };
          });

          setAssignedData(commentMappedContacts);
        });
        
      } catch (err) {
        console.error("Error fetching assignment data:", err);
        alert("Failed to load employee assignments.");
      } finally {
        setLoading(false);
      }
    };

    fetchAssignments();
  }, [id]);

  console.log("Final assignedData:", assignedData);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) return <LoadingCircular />;

  return (
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "5px",
        fontFamily: "sans-serif",
      }}
    >
      <div
        style={{
          backgroundColor: "#f5f5f5",
          border: "1px solid #ddd",
          padding: "15px",
          marginBottom: "20px",
          borderRadius: "6px",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <h5>👤 Name: {employeeInfo?.name || id}</h5>
        <h6>📧 Email: {employeeInfo?.email || id}</h6>
        <h6>📱 Phone: {employeeInfo?.mobilno || id}</h6>
      </div>

      {assignedData.length === 0 ? (
        <p style={{ color: "red", fontWeight: "bold" }}>
          No contact messages are assigned to this employee yet.
        </p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {assignedData.map((item, index) => {
            const isOpen = activeIndex === index;

            return (
              <div
                key={item.id}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  overflow: "hidden",
                }}
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  style={{
                    backgroundColor: "#e8f0fe",
                    border: "none",
                    width: "100%",
                    textAlign: "left",
                    padding: "12px 16px",
                    fontSize: "16px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span
                    style={{
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                      fontSize: "18px",
                    }}
                  >
                    ▼
                  </span>
                  {index + 1}. {item.name || "-"}
                </button>

                {isOpen && (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                      padding: "10px",
                      backgroundColor: "#fff",
                      borderTop: "1px solid #ccc",
                    }}
                  >
                    {/* Left Column: Contact Details */}
                    <div style={{ flex: 1, minWidth: "250px" }}>
                      <p>
                        <strong>Name:</strong> {item.name || "-"}
                      </p>
                      <p>
                        <strong>Email:</strong> {item.email || "-"}
                      </p>
                      <p>
                        <strong>Phone:</strong> {item.phone || "-"}
                      </p>
                      <p>
                        <strong>Message:</strong> {item.message || "-"}
                      </p>
                      <p>
                        <strong>Assigned To:</strong>{" "}
                        {item.assignedTo?.selectedEmpName || "-"}
                      </p>
                    </div>

                    {/* Right Column: Comments */}
                    <div
                      style={{
                        flex: 1,
                        minWidth: "900px",
                        backgroundColor: "#f9f9f9",
                        border: "1px solid #eee",
                        borderRadius: "4px",
                        padding: "12px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                    >
                      <div
                        style={{
                          minWidth: "900px",
                          display: "flex",
                          fontSize: "24px",
                          gap: "20px",
                          padding: "10px",
                        }}
                      >
                        <p
                          style={{
                            flex: "1 1 60%",
                            color: "green",
                            marginLeft: "5px",
                          }}
                        >
                          Comments
                        </p>
                        <p style={{ flex: "1 1 20%", color: "orange" }}>
                          Status
                        </p>
                        <p style={{ flex: "1 1 10%", color: "blue" }}>Date</p>
                      </div>
                      {item.comments && item.comments.length > 0 ? (
                        item.comments.map((commentObj, idx) => (
                          <div
                            key={idx}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              flexWrap: "wrap",
                              gap: "20px",
                              padding: "10px",
                              borderBottom: "1px solid #ddd",
                            }}
                          >
                            <div style={{ flex: "1 1 60%" }}>
                              <p style={{ fontWeight: "bold" }}>
                                {commentObj.comment}
                              </p>
                            </div>
                            <div style={{ flex: "1 1 20%" }}>
                              <p style={{ fontWeight: "bold" }}>
                                {commentObj.status}
                              </p>
                            </div>
                            <div style={{ flex: "1 1 10%" }}>
                              <p style={{ fontWeight: "bold" }}>
                                {commentObj.timestamp}
                              </p>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p style={{ color: "gray", fontStyle: "italic" }}>
                          No comments by this employee.
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default EmployeeStatus;
